type IconProps = {
  className?: string;
  size?: number;
};

export function IconEnter({ className = "", size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill="currentColor"
        d="M22.224 17.502a1.092 1.092 0 0 0-1.178.997c-.097 1.14-.216 2.131-.321 2.652v.006c-.309 1.593-1.818 3.168-3.366 3.514-.134.028-.268.054-.402.08.115-1.48.2-3.372.19-4.831.016-2.23-.197-5.662-.386-7.027-.34-2.515-1.886-5.304-3.597-6.49l-.01-.007a19.446 19.446 0 0 0-4.509-2.255 24.503 24.503 0 0 1 3.836-.287c1.748 0 3.344.16 4.879.478 1.547.345 3.056 1.92 3.365 3.514v.006c.104.518.224 1.51.32 2.645a1.092 1.092 0 1 0 2.178-.185c-.104-1.23-.233-2.282-.354-2.887-.477-2.45-2.646-4.698-5.045-5.23l-.014-.002c-1.686-.35-3.428-.522-5.333-.525a25.47 25.47 0 0 0-5.327.525l-.014.003c-1.07.237-2.095.817-2.944 1.603-.23.173-.43.382-.594.617-.75.876-1.294 1.923-1.506 3.01-.265 1.328-.565 4.775-.542 7.075-.013 1.234.067 2.799.186 4.189.063.891.135 1.667.204 2.165.34 2.515 1.886 5.305 3.598 6.49l.01.007a19.474 19.474 0 0 0 3.802 1.996c1.353.526 2.595.844 3.798.974h.01c1.616.144 3.085-1.258 3.53-3.309.376-.06.749-.128 1.118-.204l.014-.003c2.4-.531 4.568-2.78 5.045-5.23.12-.606.25-1.66.355-2.893a1.093 1.093 0 0 0-.996-1.18Z"
      />
      <path
        fill="currentColor"
        d="M31 14.499c0-.036 0-.073-.006-.109v-.007a.985.985 0 0 0-.015-.1v-.008a1.087 1.087 0 0 0-.297-.549l-3.91-3.914a1.093 1.093 0 0 0-1.546 1.546l2.051 2.05h-7.543a1.093 1.093 0 1 0 0 2.186h7.533l-2.05 2.05a1.092 1.092 0 0 0 1.546 1.545l3.893-3.893a1.084 1.084 0 0 0 .323-.586v-.015c.005-.029.01-.057.013-.088.003-.031 0-.045 0-.067v-.038L31 14.5Z"
      />
    </svg>
  );
}
